import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=a6873dbc&scoped=true"
import script from "./FileCard.vue?vue&type=script&lang=js"
export * from "./FileCard.vue?vue&type=script&lang=js"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=a6873dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6873dbc",
  null
  
)

export default component.exports